export default __webpack_public_path__ + "5f6cd1fd7d46f2b8ea4bcc65cfa7aa9c.jpg";